<svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.8022 1.61805L7.03141 7.38889L1.26058 1.61805" stroke="currentColor" stroke-width="2" />
</svg>